/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { TaskList } from '../../../common/types.tsx';
import type { State, ProjectState } from '../../model/types.tsx';
import { getAllTasks } from '../../tasks/getAllTasks.tsx';
import { nextOpenTask } from '../next-open-task/index.tsx';

type NextGetTasksProps = {
	projectState: ProjectState | null;
	taskGroupParent: string;
	taskList?: TaskList;
	isEligibleForTailoredOnboardingM2P5?: boolean;
	teamType?: string;
	features: {
		hasBacklog?: boolean;
		hasSprint?: boolean;
		hasSummaryPage?: boolean;
		hasRoadmap?: boolean;
		hasList?: boolean;
		hasCalendar?: boolean;
		hasCode?: boolean;
		hasForms?: boolean;
		hasPages?: boolean;
		hasPlanDependencies?: boolean;
		hasPlanProgram?: boolean;
		hasPlanReleases?: boolean;
		hasPlanTeams?: boolean;
	};
	permissions?: {
		canCreateIssue?: boolean;
	};
	// default value is 'project'
	containerType?: 'project' | 'plan';
};

export const nextGetTasks =
	(props: NextGetTasksProps): Action<State> =>
	({ getState, setState, dispatch }) => {
		const { taskList, completedTaskList, openTask, isQuickstartLoaded } = getState();
		const tasks = getAllTasks({ ...props, taskList });
		setState({ tasks });

		// Auto-open the first incomplete task if no task is currently open
		// Note: nextGetTasks and refreshAppState can in theory happen in any order
		// Only do this if the quickstart is fully loaded (isQuickstartLoaded = true)
		// This ensures backend state has been restored before we auto-open
		if (tasks?.items && tasks.items.length > 0 && isQuickstartLoaded) {
			const firstIncompleteTask = tasks.items.find((taskId) => !completedTaskList.includes(taskId));

			// If we found a first incomplete task and no task is currently open, open it
			if (firstIncompleteTask && !openTask) {
				dispatch(nextOpenTask(firstIncompleteTask));
			}
		}
	};
